import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { createApiUrl, getToken } from '../../../util';
import api from 'api/axiosInstance';

export interface AutoEdgeDetectionResult {
	specialEdges: SpecialEdges[]
	gutterLines: GutterLine[]
}

export const autoEdgeDetectionThunk = createAsyncThunk<
	AutoEdgeDetectionResult,
	{uuid: string},
	{ rejectValue: string }
>(
	'roofData/autoEdgeDetection',
	async ({uuid}, { rejectWithValue }) => {
		try {
			const token = getToken('Authorization');
			const { data } = await api.post<AutoEdgeDetectionResult>(
				createApiUrl(`/designs/roof/roof-segment-edges/auto-detect-edges/${uuid}`),
				{},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);
			return data;
		} catch (error) {
			const axiosError = error as AxiosError<{ message: string }>;
			return rejectWithValue(
				axiosError.response?.data?.message ?? 'Auto edge detection failed'
			);
		}
	}
);